import { FC, ReactNode } from 'react';
import { cn } from '@/utilities/cn';
import { clsx } from "clsx";

type IThumbProps = {
  selected: boolean;
  onClick: () => void;
  children: ReactNode;
};

export const Thumb: FC<IThumbProps> = props => {
  const { selected, onClick, children } = props;

  return (
    <div className='flex flex-carousel-3 md:flex-carousel-4 min-w-0 pl-3'>
      <button
        onClick={ onClick }
        type="button"
        className={ cn( 'p-0.5 rounded-lg border-2 border-transparent', selected && 'border-secondary-200' ) }
      >
        { children }
      </button>
    </div>
  );
};
